'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _MatrixQuestion = require('./MatrixQuestion');

var _MatrixQuestion2 = _interopRequireDefault(_MatrixQuestion);

var _Question = require('./Question');

var _Question2 = _interopRequireDefault(_Question);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuestionHolder = function (_Component) {
  _inherits(QuestionHolder, _Component);

  function QuestionHolder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, QuestionHolder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuestionHolder.__proto__ || Object.getPrototypeOf(QuestionHolder)).call.apply(_ref, [this].concat(args))), _this), _this.getComponent = function () {
      if (_this.props.displayType === 'matrix') {
        return _react2.default.createElement(_MatrixQuestion2.default, _this.props);
      } else {
        return _react2.default.createElement(_Question2.default, _this.props);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(QuestionHolder, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'fieldset',
        { className: 'QuestionHolder ' + this.props.displayType + 'Holder' },
        this.getComponent()
      );
    }
  }]);

  return QuestionHolder;
}(_react.Component);

QuestionHolder.propTypes = {
  id: _propTypes.PropTypes.string.isRequired,
  text: _propTypes.PropTypes.string,
  answer: _propTypes.PropTypes.any,
  choices: _propTypes.PropTypes.any,
  displayType: _propTypes.PropTypes.string
};

QuestionHolder.defaultTypes = {};

exports.default = QuestionHolder;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Survey/QuestionHolder.js
// module id = 196
// module chunks = 0